// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Button} from '../button/Button'
import {Icon} from '../icon/Icon'
import {P} from '../p/P'

import LazysizesDirective from '../../../utils/LazysizesDirective';

@Component({
    name: 'Lightbox',
    components: {
        Button,
        Icon,
        P,
    },
    mixins: [
        template,
    ],
    directives: {
        lazysizes: LazysizesDirective
    }
})
export class LightboxImg extends Vue {

    public isModalOpen: boolean = false

    @Prop()
    public thumbnail!: string

    @Prop()
    public bgThumbnail!: string

    @Prop()
    public imgSrc!: string

    @Prop()
    public bgSrc!: string

    @Prop()
    public title!: string

    @Prop({default: true})
    public hasZoom!: boolean

    @Prop({default: undefined})
    public visible!: boolean

    @Prop()
    public openIcon!: string

    @Prop()
    public lazyloadingImg?: string

    @Watch('visible')
    public watchVisible(visible){
        if (this.isModalOpen != this.visible) this.isModalOpen = this.visible
    }

    public $refs!: {
        modal: any
    }

    public created() {
        this.isModalOpen = this.visible
    }

    public mounted () {

    }

    public destroyed() {

    }

    public handleOpen(e?: Event) {
        if ( this.hasZoom ) {
            this.isModalOpen = true

            this.$emit('update:visible', true)
        }
    }

    public handleClose(e?: any) {

        this.isModalOpen = false

        this.$emit('update:visible', false)
    }
}